<h2 mat-dialog-title>{{ data.title }}</h2>

<mat-dialog-content>
  {{ data.text }}
</mat-dialog-content>

<mat-dialog-actions class="buttonsPanel-no-margin">
  @for (button of data.buttons; track button) {
    @if (button.markAsDefault) {
      <button type="button" mat-raised-button color="accent" class="margin-left-15" [mat-dialog-close]="button.value" cdkFocusInitial>{{ button.text }}</button>
    } @else {
      <button type="submit" mat-raised-button  [mat-dialog-close]="button.value">{{ button.text }}</button>
    }
  }
</mat-dialog-actions>
